import React, { Component } from "react";
import { FormGroup, FormControl, ControlLabel, HelpBlock} from "react-bootstrap";
import { Auth } from "aws-amplify";
import LoaderButton from "../components/LoaderButton";
import GoogleButton from "../components/GoogleButton";

import "./Login.css";

export default class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
        isLoading: false,
        errorMessage: null,
        email: "",
        password: "",
        showLogin: false
      };
  }

  validateForm() {
    return this.state.email.length > 0 && this.state.password.length > 0;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleSubmit = async event => {
    event.preventDefault();

    this.setState({ isLoading: true });

    try {
      await Auth.signIn(this.state.email, this.state.password);
      this.props.userHasAuthenticated(true);
    } catch (e) {
      this.setState({
        isLoading: false,
        errorMessage: e.message
      });
    }
  }

  handleGoogleLogin = () => {
    this.props.userHasAuthenticated(true);
  };

  handleShowLogin = () => {
    this.setState({
      showLogin: !this.state.showLogin
    });
  }

  render() {
    var showAfterClickingStyle = {
      'display': 'none'
    }
    var hideAfterClickingStyle = {}
    if (this.state.showLogin) {
      hideAfterClickingStyle['display'] = 'none';
      showAfterClickingStyle = {};
    }
    return (
      <div className="Login">
        <GoogleButton
          onLogin={this.handleGoogleLogin}
        />
        <hr />
        <div class="loginWithEmail"
             onClick={ this.handleShowLogin }
             style={ hideAfterClickingStyle }>
         or <b>log in with email</b>
        </div>
        <form style={ showAfterClickingStyle } onSubmit={this.handleSubmit}>
          <FormGroup controlId="email" bsSize="large">
            <ControlLabel>email</ControlLabel>
            <FormControl
              autoFocus
              type="email"
              value={this.state.email}
              onChange={this.handleChange}
            />
          </FormGroup>
          <FormGroup controlId="password" bsSize="large">
            <ControlLabel>password</ControlLabel>
            <FormControl
              value={this.state.password}
              onChange={this.handleChange}
              type="password"
            />
          </FormGroup>
          <HelpBlock>{this.state.errorMessage}</HelpBlock>
          <LoaderButton
            block
            bsStyle="primary"
            bsSize="large"
            disabled={!this.validateForm()}
            type="submit"
            isLoading={this.state.isLoading}
            text="login"
            loadingText="Logging in…"
          />
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Login.js